import {

	BufferGeometry,

	Mesh

} from 'three'

import OcclusionMeshPoint from '../../abstract/occlusionmeshpoint'

import emitter from '../../emitter'

import Geometry from './geometry'

import Material from './material'

import EVENTS from '../../globals/eventslist'

import {

	DEBUG
} from 'constants'


export default class Trail extends Mesh {

	constructor(tale){

		let geometry = new Geometry(1)

		let material = new Material()

		super(geometry, material)

		this.pickingGeo()

		this.originalGeometry = geometry
		this.originalMaterial = this.material
		this.pickingMaterial = this.material.pickingMaterial

		this.scaleY = 1

		this.addEvents()

		if(DEBUG){
		}

	}

	update(delta){

		this.material.update(delta)
	}	

	occlusion(val){

		this.material = val == true ? this.material.occlusionMaterial : this.originalMaterial
	}

	pickingGeo(){

		if(this.pickingGeom){

			this.pickingGeom.dispose()

			this.pickingGeom = null

		}

		this.pickingGeom = new Geometry(this.scaleY * 2)
	}

	resize(w,h){
		

	}

	onPicking(e){


		if(e == true){

			this.material = this.pickingMaterial
			this.geometry = this.pickingGeom

		}

		else{

			this.material = this.originalMaterial
			this.geometry = this.originalGeometry
		}

	}

	addEvents(){

		// trail.scaleY = 1.8
		emitter.on('scaleY', (val)=> {
			this.scaleY = val; this.recreate(this.scaleY); this.pickingGeo() }
		)

		emitter.on('picking', this.onPicking.bind(this))

		emitter.on(EVENTS.occlusion, this.occlustionEvent = this.occlusion.bind(this))
		emitter.on(EVENTS.update, this.updateEvent = this.update.bind(this))
		emitter.on(EVENTS.resize, this.resizeEvent = this.resize.bind(this))
	}

	recreate(val, ret = false){

		let tempGeo = new Geometry(val)

		this.geometry.dispose()

		this.geometry = null

		this.geometry = tempGeo

		this.originalGeometry = this.geometry

	}

	removeEvents(){

		emitter.off(EVENTS.update, this.updateEvent )
	}
}


// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/trail/index.js